// Browser maintenance checks do not depend on react-native-version-check.
export const WEB_PACKAGE = 'umfragetool-web';
export const POLL_INTERVAL_MS = 30000;
export const REQUEST_TIMEOUT_MS = 10000;

export function startAvailabilityPolling({
  endpoint,
  onStatus,
  onCheckComplete,
  fetchStatus = fetch,
  eventTarget = window,
}) {
  let stopped = false;
  let controller = null;

  const check = async () => {
    if (stopped || controller) return;
    controller = new AbortController();
    const timeout = setTimeout(() => controller?.abort(), REQUEST_TIMEOUT_MS);
    try {
      const response = await fetchStatus(endpoint, {
        method: 'POST',
        cache: 'no-store',
        headers: {'Content-Type': 'application/json'},
        // Web maintenance is package-based; native build thresholds do not apply.
        body: JSON.stringify({package: WEB_PACKAGE, build: null}),
        signal: controller.signal,
      });
      if (!response.ok) throw new Error(`Status check failed: HTTP ${response.status}`);
      const status = await response.json();
      if (typeof status?.inMaintenanceMode !== 'boolean') {
        throw new Error('Invalid maintenance status response');
      }
      if (!stopped) onStatus(status);
    } catch (error) {
      // Keep the last confirmed state on network, timeout, or server errors.
      if (!stopped) console.warn('Could not check maintenance status:', error.message);
    } finally {
      clearTimeout(timeout);
      controller = null;
      if (!stopped) onCheckComplete();
    }
  };

  check();
  const interval = setInterval(check, POLL_INTERVAL_MS);
  eventTarget.addEventListener('focus', check);
  eventTarget.addEventListener('online', check);
  return () => {
    stopped = true;
    clearInterval(interval);
    controller?.abort();
    eventTarget.removeEventListener('focus', check);
    eventTarget.removeEventListener('online', check);
  };
}
